var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48 1.23211V12.7521H4.496V1.23211H8.48ZM7.76 1.95211H5.216V12.0321H7.76V1.95211ZM7.424 10.4801V11.2001H5.552V10.4801H7.424ZM7.424 3.98411V4.70411H5.552V3.98411H7.424ZM7.424 2.84811V3.56811H5.552V2.84811H7.424ZM3.984 1.23211V12.7521H0V1.23211H3.984ZM3.264 1.95211H0.72V12.0321H3.264V1.95211ZM2.928 10.4801V11.2001H1.056V10.4801H2.928ZM2.928 3.82411V4.54411H1.056V3.82411H2.928ZM2.928 2.68811V3.40811H1.056V2.68811H2.928ZM12.272 0.912109L16 11.8081L12.24 13.0881L8.496 2.20811L12.272 0.912109ZM11.808 1.82411L9.408 2.65611L12.688 12.1761L15.088 11.3601L11.808 1.82411ZM14.336 9.98411L14.576 10.6561L12.8 11.2801L12.576 10.5921L14.336 9.98411ZM12.144 3.85611L12.384 4.54411L10.608 5.15211L10.384 4.48011L12.144 3.85611ZM11.808 2.76811L12.048 3.44011L10.288 4.06411L10.048 3.37611L11.808 2.76811Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/Reporting.4a66512bc68cbb58f809f4e7ba00ff5c.svg";
export { ForwardRef as ReactComponent };